export default {
  notification: null,
}
